import React from 'react';
import PropTypes from 'prop-types';

import { Input, Menu } from 'semantic-ui-react';

const SearchBox = props => (
  <Menu attached="top" tabular>
    <Menu.Menu position="right">
      <Menu.Item>
        <Input
          transparent
          icon={{ name: 'search', link: true }}
          placeholder="Search tickers"
          onChange={props.onChangeSearch}
        />
      </Menu.Item>
    </Menu.Menu>
  </Menu>
);

SearchBox.propTypes = {
  onChangeSearch: PropTypes.func.isRequired,
};

export default SearchBox;



// WEBPACK FOOTER //
// ./src/containers/Markets/components/SearchBox/index.jsx